var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-12"},[(_vm.loading)?_c('div',{staticClass:"lib__text-center"},[_c('Loader',{attrs:{"label":_vm.$t('smartMeter.workFileCreation.creatingFile')}})],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }